module.exports = __webpack_public_path__ + "img/icon_contact_04.fd642e3d.png";